import { render, staticRenderFns } from "./EditActionButtons.vue?vue&type=template&id=04b812c4&scoped=true"
import script from "./EditActionButtons.vue?vue&type=script&lang=ts"
export * from "./EditActionButtons.vue?vue&type=script&lang=ts"
import style0 from "./EditActionButtons.vue?vue&type=style&index=0&id=04b812c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b812c4",
  null
  
)

export default component.exports